import { render, staticRenderFns } from "./AmbassadorToolInvites.vue?vue&type=template&id=23f90430&"
import script from "./AmbassadorToolInvites.vue?vue&type=script&lang=js&"
export * from "./AmbassadorToolInvites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports